import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, MapPin, Users } from "lucide-react";
import { api } from "../lib/api";
import { Countdown } from "./dashboard/CastingCalls";

const MiniCall = ({ c }) => (
  <Link to={`/casting-calls/${c.id}`} className="group border border-white/10 bg-card p-6 flex flex-col hover:border-primary transition-colors" data-testid={`home-call-${c.id}`}>
    <div className="flex flex-wrap items-center gap-3"><p className="label-xs text-primary">{c.production_type || "Production"}</p><Countdown c={c} /></div>
    <h3 className="font-display text-2xl mt-2 group-hover:text-primary transition-colors">{c.production_title || `${c.extras_needed} extras needed`}</h3>
    <div className="flex flex-col gap-2 mt-4 text-sm text-white/70">
      <span className="flex items-center gap-2"><MapPin size={14} className="text-primary" />{c.location}, {c.country}</span>
      <span className="flex items-center gap-2"><CalendarDays size={14} className="text-primary" />{c.shoot_dates}</span>
      <span className="flex items-center gap-2"><Users size={14} className="text-primary" />{c.extras_needed} needed</span>
    </div>
    <span className="mt-6 text-xs font-bold uppercase tracking-wider inline-flex items-center gap-2 text-white/60 group-hover:text-primary">View call <ArrowRight size={14} /></span>
  </Link>
);

export const LatestCalls = () => {
  const [calls, setCalls] = useState([]);
  useEffect(() => {
    api.get("/public/casting-calls").then((r) => setCalls(r.data.slice(0, 3))).catch(() => setCalls([]));
  }, []);
  if (!calls.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16" data-testid="home-latest-calls">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <p className="label-xs">Casting now</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-4 leading-none">Productions looking for extras</h2>
        </div>
        <Link to="/casting-calls" className="text-primary text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2" data-testid="home-all-calls-link">All casting calls <ArrowRight size={14} /></Link>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mt-10">
        {calls.map((c) => <MiniCall key={c.id} c={c} />)}
      </div>
    </section>
  );
};
